import { cardItems } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-4">
            人气作品
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-900">
            热门漫画
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-lg mx-auto">
            千万漫迷的共同选择，口碑与热度兼具的精品漫画
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-4 md:gap-5">
          {cardItems.map((item) => (
            <article
              key={item.id}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-2 right-2">
                  <span className="px-2 py-0.5 bg-background-50/90 backdrop-blur-sm text-foreground-700 text-xs rounded flex items-center gap-1">
                    <i className="ri-star-fill text-accent-500 text-xs"></i>
                    {item.rating}
                  </span>
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-400 mt-1">{item.category}</p>
                <p className="text-xs text-foreground-500 mt-1 line-clamp-1">{item.desc}</p>
                <div className="mt-2 pt-2 border-t border-background-100 flex items-center justify-between">
                  <span className="text-xs text-foreground-400">{item.chapters}</span>
                  <span className="text-xs text-primary-600 cursor-pointer">阅读</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}